import {
  Button,
  Card,
  Container,
  Grid,
  IconButton,
  Stack,
  Tooltip,
  Typography
} from "@mui/material";
import React, { useEffect, useState } from "react";
import PaymentMethodInsertUpdateModal from "./PaymentMethodInsertUpdateModal";
import { getPaymentMethodApi, deletePaymentMethodApi } from "src/api/paymentMethodApi";
import DataTable from "react-data-table-component";
import { DeleteSharp, EditSharp } from "@mui/icons-material";
import Deletemodal from "src/pages/DeleteModal";
import { notification } from "src/utils/messages";

export default function Index() {
  const [addEditModal, setAddEditModal] = useState(false);
  const [openDeleteModal, setOpenDeleteModal] = useState({ mval: false, id: 0 });
  const [modalType, setModalType] = useState("Add");
  const [paymentMethod, setPaymentMethod] = useState([]);
  const [page, setPage] = useState(1);
  const [rowData, setRowData] = useState([]);
  const [rowsPerPage, setRowsPerPage] = useState(10);

  const toggleAddEditModal = () => setAddEditModal(!addEditModal);

  const getPaymentMethod = async () => {
    const resp = await getPaymentMethodApi();
    if (resp.status == 1) {
      setPaymentMethod(resp?.data);
    }
  };

  const deletePaymentMethod = async () => {
    const resp = await deletePaymentMethodApi({
      p_m_id: rowData.p_m_id
    });
    let notify = notification({
      type: resp.status == 0 ? "error" : "success",
      message: resp.message
    });
    notify();
    if (resp.status) getPaymentMethod();
    setOpenDeleteModal({ mval: false, id: 0 });
  };

  useEffect(() => {
    getPaymentMethod();
  }, []);

  const columns = [
    {
      name: "No",
      selector: (row, index) => (page - 1) * rowsPerPage + index + 1,
      wrap: true,
      width: "70px",
      sortable: false // Optional: disable sorting since it's just serial numbers
    },
    {
      name: "Payment Method",
      wrap: true,
      selector: (row) => row.method_name,
      sortable: true
    },
    {
      name: "Action",
      wrap: true,
      sortable: true,
      width: "200px",
      selector: (row) => (
        <>
          {row?.editable == 1 && (
            <>
              <Tooltip title="Edit Payment Method">
                <IconButton
                  onClick={() => {
                    setModalType("Edit");
                    setRowData(row);
                    toggleAddEditModal();
                  }}
                >
                  <EditSharp color="warning" />
                </IconButton>
              </Tooltip>
              <Tooltip title="Delete Payment Method">
                <IconButton
                  onClick={() => {
                    setRowData(row);
                    setOpenDeleteModal({
                      mval: true,
                      id: row.p_m_id
                    });
                  }}
                >
                  <DeleteSharp color="error" />
                </IconButton>
              </Tooltip>
            </>
          )}
        </>
      )
    }
  ];

  return (
    <>
      <Container>
        <Grid container spacing={2}>
          <Grid item xs={6}>
            <Stack direction="row" alignItems="center" justifyContent="space-between" mb={1}>
              <Typography variant="h4" gutterBottom>
                Payment Method
              </Typography>
            </Stack>
          </Grid>
          <Grid item xs={6}>
            <Button
              onClick={() => {
                toggleAddEditModal();
                setModalType("Add");
              }}
              style={{ marginBottom: "15px", float: "right" }}
              variant="contained"
            >
              Add Payment Method
            </Button>
          </Grid>
        </Grid>

        <Card spacing={3} style={{ padding: "10px", marginTop: "20px" }}>
          <DataTable
            pagination
            highlightOnHover
            paginationServer={false}
            onChangePage={(p) => setPage(p)}
            paginationDefaultPage={page}
            paginationPerPage={rowsPerPage}
            onChangeRowsPerPage={(newPerPage, page) => {
              setRowsPerPage(newPerPage);
              setPage(page);
            }}
            columns={columns}
            data={paymentMethod != null ? paymentMethod : []}
          />
        </Card>
      </Container>
      {addEditModal && (
        <PaymentMethodInsertUpdateModal
          addEditModal={addEditModal}
          setAddEditModal={setAddEditModal}
          modalType={modalType}
          toggleAddEditModal={toggleAddEditModal}
          rowData={rowData}
          getPaymentMethod={getPaymentMethod}
        />
      )}

      <Deletemodal
        visible={openDeleteModal}
        setVisible={setOpenDeleteModal}
        deletefunc={deletePaymentMethod}
      />
    </>
  );
}
